import React from 'react';
import classNames from 'classnames';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';

import styles from './typeahead-overlay.scss';

interface CloseButtonProps {
  isTypeaheadOpen: boolean;
  onCloseButtonClick: () => void;
  onTabOut?: () => void;
  isConvoSearchActive?: boolean;
}

export const CloseButton = ({
  isTypeaheadOpen,
  onCloseButtonClick,
  onTabOut = () => {},
  isConvoSearchActive = false,
}: CloseButtonProps) => {
  const closeButtonClasses = classNames([styles.bpCloseButton], {
    [styles.bpCloseButton__hidden]: !isTypeaheadOpen,
    [styles.bpCloseButton__withButton]: isConvoSearchActive,
  });

  return (
    <button
      data-testid={`close-expanded-search`}
      className={closeButtonClasses}
      onClick={onCloseButtonClick}
      onBlur={onTabOut}
      aria-label="Close search"
    >
      <CloseOutlined className={styles.closeIcon} size="medium" />
    </button>
  );
};
